import { render, staticRenderFns } from "./identify.vue?vue&type=template&id=4429d1a5&scoped=true&"
import script from "./identify.vue?vue&type=script&lang=js&"
export * from "./identify.vue?vue&type=script&lang=js&"
import style0 from "./identify.vue?vue&type=style&index=0&id=4429d1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4429d1a5",
  null
  
)

export default component.exports